import http from "../services/http";

// Join video call and get Agora token
export const apiJoinVideoCall = async (channel) => {
  try {
    const response = await http.post("/api/video-call/join", {
      channel: channel,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};